import React from 'react'

import { isFunction } from 'lodash'

import { ui, forms } from 'parking-react-common'

import Button from '../components/Button'
import { Row, Column } from '../components/Grid'

import './FormButtons.css'

const FormButtons = (props) => {
    const { onCancel, isSubmitting, isPristine, t } = props

    return (
        <Row className="form-buttons">
            <Column span={ 3 } />
            <Column span={ 3 }>
                <Button
                    type="submit"
                    label={ t('Save') }
                    size={ ui.SIZE.large }
                    intent={ ui.INTENT.primary }
                    isBlock
                    disabled={ isSubmitting || isPristine }
                />
            </Column>
            { isFunction(onCancel) && (
                <Column span={ 3 }>
                    <Button
                        label={ t('Cancel') }
                        size={ ui.SIZE.large }
                        onClick={ onCancel }
                        isBlock
                    />
                </Column>
            ) }
        </Row>
    )
}

FormButtons.propTypes = forms.propTypes

export default FormButtons
